if (!window.Eurus.loadedScript.has('coupon-code.js')) {
  window.Eurus.loadedScript.add('coupon-code.js');

  const registerCouponCode = () => {
    if (!window.Alpine || window.__mukCouponCodeRegistered) return;
    window.__mukCouponCodeRegistered = true;

    const getRenderedDiscountCodes = (htmlText = null, selector = '#CartDrawer') => {
      let scope;
      if (htmlText) {
        const doc = new DOMParser().parseFromString(htmlText, 'text/html');
        scope = doc.querySelector(selector) || doc;
      } else {
        scope = document.querySelector(selector) || document;
      }
      return [...scope.querySelectorAll('.x-discount[data-discount-type="discount_code"]')]
        .map(el => String(el.getAttribute('data-discount-code') || el.querySelector('.discount-title')?.textContent || '').trim())
        .filter(Boolean);
    };

    const getResponseSectionHtml = (response) => {
      if (!response || !response.sections) return '';
      return response.sections['cart-drawer'] || '';
    };

    const renderReturnedSections = (response) => {
      if (!response || !response.sections) return;
      Alpine.store('xCartHelper').getSectionsToRender().forEach(section => {
        const sectionElement = document.querySelector(section.selector);
        const html = response.sections[section.id];
        if (sectionElement && html) {
          sectionElement.innerHTML = getSectionInnerHTML(html, section.selector);
        }
      });
    };

    const syncAppliedCodes = (codes) => {
      const unique = [...new Set((codes || []).map(code => String(code).trim()).filter(Boolean))];
      Alpine.store('xCouponCodeDetail').appliedDiscountCodes = unique;
      document.cookie = `eurus_discount_code=${encodeURIComponent(unique.join(','))}; path=/; SameSite=Lax`;
      return unique;
    };

    Alpine.data('xCouponCodeList', (sectionId) => ({
      loading: true,
      load() {
        this.loading = true;
        const url = `${window.location.pathname}?section_id=${sectionId}`;
        fetch(url)
          .then(response => response.text())
          .then(responseText => {
            const html = (new DOMParser()).parseFromString(responseText, 'text/html');
            const contentId = `x-promo-code-list-${sectionId}`;
            const newContent = html.getElementById(contentId);
            const container = document.querySelector(`[data-section-id="${sectionId}"]`) || document.body;
            if (newContent && !document.getElementById(contentId)) container.appendChild(newContent);
          })
          .finally(() => { this.loading = false; });
      }
    }));

    Alpine.data('xCouponCode', (freeShippingCodes = []) => ({
      copySuccess: false,
      loading: false,
      disableCoupon: false,
      disableComing: false,
      discountCode: '',
      errorMessage: false,
      appliedDiscountCode: false,

      init() {
        // Prevent stale/undefined model values after AJAX section replacement.
        if (typeof this.discountCode !== 'string') this.discountCode = '';
        Alpine.store('xCouponCodeDetail').getDiscountCode();
      },

      load(discountCode) {
        this.setAppliedButton(discountCode);
        document.addEventListener('eurus:cart:discount-code:change', () => this.setAppliedButton(discountCode));
      },

      copyCode() {
        if (this.copySuccess || !this.$refs.code_value) return;
        const code = this.$refs.code_value.textContent.trim();
        navigator.clipboard.writeText(code).then(() => {
          this.copySuccess = true;
          document.dispatchEvent(new Event('copy'));
          setTimeout(() => { this.copySuccess = false; }, 5000);
        }).catch(() => alert('Copy fail'));
      },

      async applyCouponCode(rawCode, isCart = false) {
        const store = Alpine.store('xCouponCodeDetail');
        store.discountFaild = false;
        store.discountApplied = false;
        store.discountCorrect = false;

        const discountCode = String(rawCode ?? '').trim();
        if (!discountCode || this.loading) return false;

        store.getDiscountCode();
        const currentCodes = Array.isArray(store.appliedDiscountCodes) ? [...store.appliedDiscountCodes] : [];
        const alreadyApplied = currentCodes.some(code => String(code).toLowerCase() === discountCode.toLowerCase());

        if (Array.isArray(freeShippingCodes) && freeShippingCodes.some(code => String(code).toLowerCase() === discountCode.toLowerCase())) {
          store.freeShippingApplied = true;
          setTimeout(() => { store.freeShippingApplied = false; }, 5000);
          return false;
        }

        if (alreadyApplied) {
          store.discountApplied = true;
          this.discountCode = '';
          setTimeout(() => { store.discountApplied = false; }, 3000);
          return true;
        }

        const requestedCodes = [...new Set([...currentCodes, discountCode])];
        this.loading = true;
        store.loading = true;

        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              discount: requestedCodes.join(','),
              sections: Alpine.store('xCartHelper').getSectionsToRender().map(section => section.id),
              sections_url: window.location.pathname + window.location.search
            })
          });

          const cart = await response.json();
          if (!response.ok || cart.status === 422) throw cart;

          // Shopify's AJAX Cart JSON does NOT expose Storefront API `discount_codes`.
          // Validate against the freshly-rendered Liquid cart section, which contains
          // cart.cart_level_discount_applications after the discount mutation.
          const drawerHtml = getResponseSectionHtml(cart);
          const renderedCodes = drawerHtml ? getRenderedDiscountCodes(drawerHtml, '#CartDrawer') : [];
          const applied = renderedCodes.some(code => code.toLowerCase() === discountCode.toLowerCase());

          syncAppliedCodes(renderedCodes);
          renderReturnedSections(cart);

          const responseCount = Number.parseInt(cart.item_count, 10);
          if (Number.isFinite(responseCount)) {
            Alpine.store('xCartHelper').currentItemCount = responseCount;
            window.mukSyncCartCount?.(responseCount);
          }

          document.dispatchEvent(new CustomEvent('eurus:cart:discount-code:change'));

          if (applied) {
            store.discountCorrect = true;
            store.discountFaild = false;
            this.discountCode = '';
          } else {
            store.discountFaild = true;
            store.discountCorrect = false;
          }

          if (!isCart && Alpine.store('xCartHelper').currentItemCount > 0) Alpine.store('xMiniCart').openCart();
          return applied;
        } catch (error) {
          console.error('Discount application failed:', error);
          store.discountFaild = true;
          store.discountCorrect = false;
          return false;
        } finally {
          this.loading = false;
          store.loading = false;
          store.removedDiscountCode = '';
          setTimeout(() => { store.discountFaild = false; }, 5000);
          setTimeout(() => { store.discountCorrect = false; }, 3000);
        }
      },

      handleScheduleCoupon(el) {
        const settings = xParseJSON(el.getAttribute('x-countdown-data'));
        const timeSettings = Alpine.store('xHelper').handleTime(settings);
        if (timeSettings.distance < 0 && settings.set_end_date) this.disableCoupon = true;
        else if (timeSettings.startTime > timeSettings.now) {
          this.disableCoupon = true;
          this.disableComing = true;
        }
      },

      onChange() {
        // x-model is authoritative; this keeps compatibility with old markup.
        this.discountCode = String(this.$el?.value ?? '').trim();
      },

      applyDiscountToCart() {
        return this.applyCouponCode(this.discountCode, true);
      },

      undoRemoveDiscount() {
        return this.applyCouponCode(Alpine.store('xCouponCodeDetail').removedDiscountCode, true);
      },

      setAppliedButton(discountCode) {
        const applied = Alpine.store('xCouponCodeDetail').appliedDiscountCodes || [];
        this.appliedDiscountCode = !!discountCode && applied.some(code => String(code).toLowerCase() === String(discountCode).toLowerCase());
      }
    }));

    Alpine.store('xCouponCodeDetail', {
      show: false,
      promoCodeDetail: {},
      sectionID: '',
      discountCodeApplied: '',
      appliedDiscountCodes: [],
      removedDiscountCode: '',
      cachedResults: [],
      loading: false,
      cartEmpty: true,
      discountFaild: false,
      discountApplied: false,
      freeShippingApplied: false,
      discountCorrect: false,

      handleCouponSelect(shopUrl) {
        const promoCodeDetail = JSON.parse(JSON.stringify(this.promoCodeDetail || {}));
        document.addEventListener('shopify:section:select', event => {
          if (!event.target.classList.contains('section-promo-code')) this.close();
        });
        if (promoCodeDetail.blockID && promoCodeDetail.sectionID) this.load(document.getElementById('x-data-promocode-' + promoCodeDetail.blockID), promoCodeDetail.blockID, shopUrl);
      },

      load(el, blockID, shopUrl) {
        if (!el) return;
        this.promoCodeDetail = xParseJSON(el.getAttribute('x-data-promocode'));
        const contentContainer = document.getElementById('PromoCodeContent-' + this.promoCodeDetail.sectionID);
        this.sectionID = this.promoCodeDetail.sectionID;
        if (!contentContainer) return;
        if (this.cachedResults[blockID]) {
          contentContainer.innerHTML = this.cachedResults[blockID];
          return;
        }
        if (this.promoCodeDetail.page) {
          this.loading = true;
          fetch(`${shopUrl}/pages/${this.promoCodeDetail.page}`)
            .then(r => r.text())
            .then(text => {
              const html = new DOMParser().parseFromString(text, 'text/html');
              const content = html.querySelector('.page__container .page__body')?.innerHTML || '';
              contentContainer.innerHTML = content;
              this.cachedResults[blockID] = content;
            })
            .finally(() => { this.loading = false; });
        } else if (this.promoCodeDetail.details) {
          contentContainer.innerHTML = this.promoCodeDetail.details;
          contentContainer.innerHTML = contentContainer.textContent;
        }
      },

      showPromoCodeDetail() {
        this.show = true;
        Alpine.store('xPopup').open = true;
      },

      close() {
        this.show = false;
        Alpine.store('xPopup').close();
      },

      async removeDiscountCode(el, isCart = false) {
        this.discountFaild = false;
        this.discountApplied = false;
        this.discountCorrect = false;
        this.getDiscountCode();

        const row = el.closest('li.x-discount');
        const discountCode = String(row?.getAttribute('data-discount-code') || row?.querySelector('.discount-title')?.textContent || '').trim();
        if (!discountCode || this.loading) return;

        const remainingCodes = (this.appliedDiscountCodes || []).filter(code => String(code).toLowerCase() !== discountCode.toLowerCase());
        this.loading = true;

        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              discount: remainingCodes.join(','),
              sections: Alpine.store('xCartHelper').getSectionsToRender().map(section => section.id),
              sections_url: window.location.pathname + window.location.search
            })
          });
          const cart = await response.json();
          if (!response.ok || cart.status === 422) throw cart;

          const drawerHtml = getResponseSectionHtml(cart);
          const renderedCodes = drawerHtml ? getRenderedDiscountCodes(drawerHtml, '#CartDrawer') : [];
          syncAppliedCodes(renderedCodes);
          renderReturnedSections(cart);

          const responseCount = Number.parseInt(cart.item_count, 10);
          if (Number.isFinite(responseCount)) {
            Alpine.store('xCartHelper').currentItemCount = responseCount;
            window.mukSyncCartCount?.(responseCount);
          }
          document.dispatchEvent(new CustomEvent('eurus:cart:discount-code:change'));
          this.removedDiscountCode = discountCode;
        } catch (error) {
          console.error('Discount removal failed:', error);
          this.discountFaild = true;
        } finally {
          this.loading = false;
          setTimeout(() => { this.discountFaild = false; }, 5000);
          setTimeout(() => { this.discountCorrect = false; }, 3000);
        }
      },

      clearRemovedDiscount() { this.removedDiscountCode = ''; },

      getDiscountCode() {
        // First trust what Liquid has actually rendered in the current cart.
        const rendered = getRenderedDiscountCodes(null, '#CartDrawer');
        if (rendered.length) {
          this.appliedDiscountCodes = rendered;
          return rendered;
        }
        // Cookie is fallback only (e.g. before the drawer has mounted).
        const match = document.cookie.match('(?:^|;)\\s*eurus_discount_code\\s*=\\s*([^;]+)');
        const raw = match ? decodeURIComponent(match.pop() || '') : '';
        this.appliedDiscountCodes = raw ? raw.split(',').map(v => v.trim()).filter(Boolean) : [];
        return this.appliedDiscountCodes;
      }
    });
  };

  // If Alpine already exists (e.g. section script loaded after initialisation), register now.
  if (window.Alpine) registerCouponCode();
  document.addEventListener('alpine:init', registerCouponCode, { once: true });
}
